import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { featureFlipping } from '../core/feature-flipping';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlipping implements CanActivate {
  canActivate(): boolean {
    if (featureFlipping.admin) {
      return true;
    } else {
      return false;
    }
  }
}
